import { ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material"
import { TestData } from "graphql/types"
import { getTimeDifferencFormated } from "utils/dateTimeUtils"
import { getImageURL } from "utils/getFileURL"

type TaskHelperCardProps = {
  testData: TestData
}

export const TaskHelperCard = (props: TaskHelperCardProps) => {
  const { testData } = props

  const helperList = testData.helper?.map((item) => item.displayName).join(", ") || ""

  return (
    <>
      <Typography variant="body2">{testData.description}</Typography>

      <Typography variant="body2">Helfer: {helperList}</Typography>

      <Typography variant="body2">
        Arbeitszeit: {getTimeDifferencFormated(testData.beginTime, testData.endTime)}
      </Typography>

      <ImageList sx={{ width: "100%" }} cols={4}>
        {testData.image?.map((item) => (
          <ImageListItem key={item.id}>
            <img src={getImageURL(item.id)} alt={item.name} />
            <ImageListItemBar title={item.name} position="below" />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  )
}
